import { Col, Gallery, Row, Typography } from '@repo/ui/components'
import Image from 'next/image'
import { AgentPost } from '@repo/services'
import { globalConfig } from '@repo/shared/utils'

export const getLogoUrl = (url?: string) =>
  url ? `${globalConfig.baseImageUrl}${url}` : '/images/placeholder.webp'

export const PropertyDetails = ({ post }: { post: AgentPost }) => {
  const galleryImages = post?.photos
    ? post?.photos
        ?.map((photo) => getLogoUrl(photo.bigURL))
        .filter((url): url is string => Boolean(url)) || []
    : []
  return (
    <>
      <Col className='gap-md w-full'>
        <Typography size='sm' className='wrap-anywhere'>
          {post?.body}
        </Typography>
      </Col>

      {/* Property Features */}
      {post?.pros && (
        <Row className='gap-md flex-wrap mb-sm'>
          {post?.pros?.map((item, index) => (
            <Typography
              key={`positive-${index}`}
              size='sm'
              color={'text-positive-surface-100'}
            >
              {'+'} {item}
            </Typography>
          ))}
          {post?.cons?.map((item, index) => (
            <Typography
              key={`negative-${index}`}
              size='sm'
              color={'text-negative-surface-100'}
            >
              {'-'} {item}
            </Typography>
          ))}
        </Row>
      )}

      <Gallery
        images={galleryImages || []}
        sameSize={true}
        maxCount={2}
        renderImage={({ src, alt, className, sizes, style }) => (
          <Image
            src={src}
            alt={alt}
            fill
            className={className}
            sizes={sizes}
            style={style}
            unoptimized
          />
        )}
      />
    </>
  )
}
